import React from 'react';
import { useHistory } from 'react-router-dom';
import { useOnboardingContext } from '../../../contexts/Onboarding';
import { useSnackbarContext } from '../../../contexts/Snackbar';
import { useLinesContext } from '../../../contexts/Lines';
import { useEventTrackerContext } from '../../../contexts/EventTracker';
import { urlValidation, pathname } from '../../../utils';
import { addProduct, updateProduct } from '../../API/product';
import { Field } from 'formik';
import { TextField } from 'formik-material-ui';
import * as yup from 'yup';
import messages from '../../../messages';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Step from '../BuildingBlocks/Stepper/Step';
import cloneDeep from 'lodash.clonedeep';
import ProductDetails from './product-details/ProductDetails';

const useStyles = makeStyles((theme) => ({
  field: {
    maxWidth: 400,
    '& .MuiOutlinedInput-root': {
      borderRadius: theme.spacing(1),
    },
  },
}));

const nextStep = pathname.onboarding.main.productName;

export default function ProductUrl() {
  const history = useHistory();
  const classes = useStyles();
  const snackbar = useSnackbarContext();
  const { setLoading, setActiveStep } = useOnboardingContext();
  const { products, setProducts } = useLinesContext();
  const { trackEvent } = useEventTrackerContext();

  const newestProduct = products[products?.length - 1];

  async function handleSubmit(values: { url: string }) {
    try {
      if (newestProduct) {
        if (newestProduct?.url !== values.url) {
          setLoading(true);
          await updateProduct(newestProduct?.id, { url: values.url });
          const updatedProducts = cloneDeep(products).map((product) => {
            if (product.id === newestProduct.id) {
              product['url'] = values.url;
            }
            return product;
          });
          setProducts(updatedProducts);
        }
      } else {
        setLoading(true);
        const product = await addProduct({ url: values.url });
        const updatedProducts = cloneDeep(products);
        updatedProducts.push({ id: product.id, url: values.url });
        setProducts(updatedProducts);
      }
      trackEvent({ event: 'entered_product_url', product_url: values.url });
      setActiveStep(nextStep.stepInStepper);
      history.push(nextStep.url);
    } catch (error) {
      snackbar.show(messages.general.saveError, 'error');
    }
    setLoading(false);
  }

  return (
    <Step
      initialValues={{ url: newestProduct?.url || '' }}
      validationSchema={yup.object({
        url: urlValidation,
      })}
      onSubmit={handleSubmit}
      component={() => {
        return (
          <ProductDetails product={newestProduct} step={1}>
            <Field
              name="url"
              label="Product URL"
              component={TextField}
              variant="outlined"
              fullWidth
              className={classes.field}
            />
          </ProductDetails>
        );
      }}
    />
  );
}
